interface JiraiQuestionCardProps {
  questionNumber: number;
  questionText: string;
  selectedValue: number | null;
  onSelect: (value: number) => void;
}

const buttonSizes = [44, 40, 36, 32, 36, 40, 44];

const JiraiQuestionCard = ({
  questionNumber,
  questionText,
  selectedValue,
  onSelect,
}: JiraiQuestionCardProps) => {
  return (
    <div
      className="rounded-2xl px-5 py-8"
      style={{
        background: selectedValue !== null ? 'rgba(225,29,72,0.04)' : '#ffffff',
        border: selectedValue !== null
          ? '1.5px solid rgba(225,29,72,0.35)'
          : '1.5px solid rgba(225,29,72,0.15)',
        transition: 'all 0.3s ease',
      }}
    >
      {/* 設問番号バッジ */}
      <div className="flex justify-center mb-5">
        <span
          className="text-[10px] tracking-[0.45em] font-semibold px-4 py-1 rounded-full"
          style={{
            color: '#e11d48',
            background: 'rgba(225,29,72,0.08)',
            border: '1px solid rgba(225,29,72,0.2)',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
          }}
        >
          Q{questionNumber}
        </span>
      </div>

      {/* 設問テキスト */}
      <p
        className="text-[#1a1a2e] text-[16px] font-medium text-center leading-relaxed mb-10"
        style={{
          fontFamily: "'M PLUS Rounded 1c', sans-serif",
          lineHeight: '1.85',
        }}
      >
        {questionText}
      </p>

      {/* ラベル */}
      <div className="flex justify-between mb-4 px-1">
        <span
          className="text-[11px] font-semibold"
          style={{ color: '#e11d48', fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          そう思う
        </span>
        <span
          className="text-[11px]"
          style={{ color: '#9ca3af', fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          そう思わない
        </span>
      </div>

      {/* 7段階ボタン */}
      <div className="flex items-center justify-between gap-1">
        {[0, 1, 2, 3, 4, 5, 6].map((index) => {
          const isSelected = selectedValue === index;
          const size = buttonSizes[index];
          return (
            <button
              key={index}
              onClick={() => onSelect(index)}
              className="rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 cursor-pointer"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                minWidth: `${size}px`,
                minHeight: `${size}px`,
                background: isSelected
                  ? 'linear-gradient(135deg, #e11d48 0%, #9f1239 100%)'
                  : 'rgba(225,29,72,0.06)',
                border: isSelected
                  ? '2px solid #e11d48'
                  : '2px solid rgba(225,29,72,0.2)',
                boxShadow: isSelected ? '0 4px 16px rgba(225,29,72,0.3)' : 'none',
                transform: isSelected ? 'scale(1.1)' : 'scale(1)',
              }}
              aria-label={`Q${questionNumber}: 選択肢 ${index + 1}`}
            >
              {isSelected && (
                <div className="w-2.5 h-2.5 rounded-full bg-white" />
              )}
            </button>
          );
        })}
      </div>

      {selectedValue !== null && (
        <p
          className="text-center text-[10px] tracking-[0.3em] mt-5"
          style={{
            color: 'rgba(225,29,72,0.5)',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
          }}
        >
          次の設問へ...
        </p>
      )}
    </div>
  );
};

export default JiraiQuestionCard;
